import _axios from "@/axios";
import { reactive, ref } from "@vue/composition-api";
import { showSnackBar } from "@/composables/snackbar";
import { handleFormErrors } from "@/composables/form-error";

const cardModels = ref([]);
export function useCardModel() {
  const cardModelData = reactive({
    cardModelForm: {},
    cardModelFormRef: null,
    rules: {
      idle_timeoutRules: [
        (v) => !!v || "Champ obligatoire",
        (v) => v > 0 || "Doit être supérieur à 0",
      ],
      simultaneous_sessions_numRules: [],
      max_connection_durationRules: [],
      max_usage_durationRules: [],
      descriptionRules: [(v) => !!v || "Champ obligatoire"],
      label_frenchRules: [(v) => !!v || "Champ obligatoire"],
      label_englishRules: [(v) => !!v || "Champ obligatoire"],
    },
    createCardModelDialog: false,
    editCardModelDialog: false,
    cardOriginsChoice: [
      { text: "Interne", value: 1 },
      { text: "CB", value: 2 },
      { text: "Gratuit", value: 3 },
      { text: "E-ticketing client", value: 4 },
      { text: "Exception MAC", value: 5 },
      { text: "Conférence", value: 6 },
      { text: "Prévente", value: 7 },
    ],
    cardTypesChoice: [
      { text: "Décompte", value: 1 },
      { text: "Temps", value: 2 },
      { text: "Séminaire", value: 3 },
      { text: "Post payé", value: 4 },
    ],
    isLoading: false,
  });

  function listCardModels(partnerId = null, cardOriginId = null) {
    const params = new URLSearchParams({});
    if (partnerId != null) {
      params.set("partner", partnerId);
    }
    if (cardOriginId != null) {
      params.set("cardOrigin", cardOriginId);
    }

    return _axios
      .get("/list-card-model?" + params.toString())
      .then((response) => {
        cardModels.value = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function createCardModel(partnerId) {
    cardModelData.isLoading = true;
    cardModelData.createCardModelDialog = true;
    cardModelData.cardModelForm.partner = partnerId;

    if (cardModelData.cardModelFormRef != null) {
      const isValid = cardModelData.cardModelFormRef.validate();
      if (!isValid) {
        cardModelData.isLoading = false;
        return;
      }
    }

    return _axios
      .post("/create-card-model", cardModelData.cardModelForm)
      .then(() => {
        listCardModels(partnerId);
        showSnackBar();
        cardModelData.createCardModelDialog = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          cardModelData.rules,
          cardModelData.cardModelFormRef
        );
      })
      .finally(() => {
        cardModelData.isLoading = false;
      });
  }

  function updateCardModel(cardModel, partner) {
    cardModelData.isLoading = true;
    cardModelData.editCardModelDialog = true;
    if (cardModelData.cardModelFormRef != null) {
      const isValid = cardModelData.cardModelFormRef.validate();
      if (!isValid) {
        cardModelData.isLoading = false;
        return;
      }
    }

    return _axios
      .put("/card-model/" + cardModel.id, cardModelData.cardModelForm)
      .then(() => {
        listCardModels(partner.id);
        cardModelData.editCardModelDialog = false;
        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          cardModelData.rules,
          cardModelData.cardModelFormRef
        );
      })
      .finally(() => {
        cardModelData.isLoading = false;
      });
  }

  function deleteCardModel(cardModel, partner) {
    return _axios
      .delete("/card-model/" + cardModel.id)
      .then(() => {
        listCardModels(partner.id);
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  return {
    cardModels,
    listCardModels,
    cardModelData,
    createCardModel,
    updateCardModel,
    deleteCardModel,
  };
}
